// @flow @jsx h

import { h } from 'preact'
import style from './index.css'
import Video from '@nrk/dh-video-component'

import type { Media, Viewport } from '../../types'

type Props = Media & {
  mediaBaseUrl: string,
  viewport: Viewport
}

function LeadMedia (props: Props) {
  const { poster, sources, type, mediaBaseUrl, viewport } = props

  const inlineStyle = {}
  const gradientInlineStyle = {}

  if (viewport.height > -1) {
    if (viewport.width < 720) {
      inlineStyle.height = `${viewport.height - 375}px`
    } else {
      inlineStyle.height = `${viewport.height - 55}px`
    }
  }

  if (viewport.width >= 720) {
    gradientInlineStyle.height = `${viewport.height * 0.7}px`
  }

  let children

  switch (type) {
    case 'videoLoop': {
      children = (
        <Video
          className={style.leadMedia__videoLoop}
          playing
          loop
          poster={`${mediaBaseUrl}${poster}`}
          sources={sources.map(source => ({
            type: source.type,
            src: `${mediaBaseUrl}${source.src}`
          }))}
          mediaBaseUrl={mediaBaseUrl}
          style={inlineStyle}
        />
      )
      break
    }
  }

  return (
    <div className={style.leadMedia} style={inlineStyle}>
      {children}
      <div className={style.leadMedia__gradient} style={gradientInlineStyle} />
    </div>
  )
}

export default LeadMedia



// WEBPACK FOOTER //
// ./src/v1/components/Article/Header/LeadMedia/index.js